import React, { useEffect, useRef } from "react";

export default function DraggableScroller(props) {
    const ref = useRef(null);
    const stateRef = useRef({});

    useEffect(() => {
        const slider = ref.current;
        const state = stateRef.current;
        
        state.pos = { top: 0, left: 0, x: 0, y: 0 };

        const mouseMoveHandler = function (e) {
            const dx = e.clientX - state.pos.x;
            const dy = e.clientY - state.pos.y;
    
            slider.scrollTop = state.pos.top - dy;
            slider.scrollLeft = state.pos.left - dx;

            state.hasMoved = true;
        };

        const mouseClickHandler = function(e) {
            if (state.hasMoved) {
                e.preventDefault();
                e.stopPropagation();
                state.hasMoved = false;
            }
        };
    
        const mouseUpHandler = function () {
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
            document.removeEventListener('click', mouseClickHandler);
        };
    
        const mouseDownHandler = function (e) {
            state.pos = {
                left: slider.scrollLeft,
                top: slider.scrollTop,
                x: e.clientX,
                y: e.clientY,
            };
    
            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
            document.addEventListener('click', mouseClickHandler, true);
        };
    
        slider.addEventListener('mousedown', mouseDownHandler);
    }, []);

    return (
        <div {...props} ref={ref}>
            {props.children}
        </div>
    );
}
